import { SET_LAST_SEARCH_QUERY, SET_ADDRESS_IS_VERIFIED } from '@/utils/store/mutationTypes'

export default {
  /**
   * Sets the last query the user selected to state
   */
  [SET_LAST_SEARCH_QUERY] (state, { searchQuery }) {
    state.lastSearchQuery = searchQuery
  },

  /**
   * Sets the last query the user selected to state
   */
  [SET_ADDRESS_IS_VERIFIED] (state, isVerified) {
    state.addressIsVerified = isVerified
  }
}
